export enum INDICATA_RELS {
    SEQUENCE = 'sequence',
    REGISTRATION_NUMBER = 'reg',
    TEXT = 'text',
}

export enum INDICATA_RESPONSE_STEP_RELATION {
    BODY = 'body',
    BODYHEIGHT = 'bodyHeight',
    BODYLENGTH = 'bodyLength',
    CATEGORY = 'category',
    ENGINE = 'engine',
    FACELIFT = 'facelift',
    MAKE = 'make',
    MODEL = 'model',
    ODOMETER = 'odometer',
    REGISTRATION_DATE = 'regDate', // Which is the key for both month and year, on the summary (Thumbs up)
    REGISTRATION_MONTH = 'regmonth',
    REGISTRATION_YEAR = 'regdate',
    REGISTRATION_YEAR_UMBRACO = 'regyear',
    SEATS = 'seats',
    TRANSMISSION = 'transmission',
    TRIM = 'trim',
    WEIGHT = 'weight',
    WHEELDRIVE = 'wheeldrive',
    WHEELDRIVE_REL_FOR_SUMMARY_ORDER = 'wheelDrive',
}

export const indicataStepsOrder: (
    | INDICATA_RESPONSE_STEP_RELATION.BODY
    | INDICATA_RESPONSE_STEP_RELATION.BODYHEIGHT
    | INDICATA_RESPONSE_STEP_RELATION.BODYLENGTH
    | INDICATA_RESPONSE_STEP_RELATION.CATEGORY
    | INDICATA_RESPONSE_STEP_RELATION.ENGINE
    | INDICATA_RESPONSE_STEP_RELATION.FACELIFT
    | INDICATA_RESPONSE_STEP_RELATION.MAKE
    | INDICATA_RESPONSE_STEP_RELATION.MODEL
    | INDICATA_RESPONSE_STEP_RELATION.ODOMETER
    | INDICATA_RESPONSE_STEP_RELATION.REGISTRATION_DATE
    | INDICATA_RESPONSE_STEP_RELATION.SEATS
    | INDICATA_RESPONSE_STEP_RELATION.TRANSMISSION
    | INDICATA_RESPONSE_STEP_RELATION.TRIM
    | INDICATA_RESPONSE_STEP_RELATION.WHEELDRIVE_REL_FOR_SUMMARY_ORDER
    | INDICATA_RESPONSE_STEP_RELATION.WEIGHT
)[] = [
    INDICATA_RESPONSE_STEP_RELATION.CATEGORY,
    INDICATA_RESPONSE_STEP_RELATION.MAKE,
    INDICATA_RESPONSE_STEP_RELATION.MODEL,
    INDICATA_RESPONSE_STEP_RELATION.REGISTRATION_DATE,
    INDICATA_RESPONSE_STEP_RELATION.BODY,
    INDICATA_RESPONSE_STEP_RELATION.FACELIFT,
    INDICATA_RESPONSE_STEP_RELATION.SEATS,
    INDICATA_RESPONSE_STEP_RELATION.BODYHEIGHT,
    INDICATA_RESPONSE_STEP_RELATION.BODYLENGTH,
    INDICATA_RESPONSE_STEP_RELATION.WEIGHT,
    INDICATA_RESPONSE_STEP_RELATION.ENGINE,
    INDICATA_RESPONSE_STEP_RELATION.WHEELDRIVE_REL_FOR_SUMMARY_ORDER,
    INDICATA_RESPONSE_STEP_RELATION.TRANSMISSION,
    INDICATA_RESPONSE_STEP_RELATION.TRIM,
    INDICATA_RESPONSE_STEP_RELATION.ODOMETER,
];

export interface IIndicataResponseItem {
    link?: {
        href?: string;
    };
    summary?: string;
}
export interface IIndicataResponseConditionItem {
    grade: number;
}
export interface IIndicataResponseEngineItem {
    description?: IIndicataResponseStepDescription[];
    link?: {
        href?: string;
    };
    summary?: string;
}
export interface IIndicataResponseOdometerItem {
    odometerType?: string;
    distance?: number;
    unit?: string;
}

export interface IIndicataResponseStepImage {
    links?: {
        href?: string;
    }[];
}
export interface IIndicataResponseStepDescription {
    label?: string;
    value?: string;
}
export interface IIndicataResponseStep {
    href?: string;
    description?: IIndicataResponseStepDescription[];
    images?: IIndicataResponseStepImage[];
    rel?: INDICATA_RESPONSE_STEP_RELATION;
    summary?: string;
}
export interface IIndicataResponse {
    body?: IIndicataResponseItem;
    category?: IIndicataResponseItem;
    country?: string;
    engine?: IIndicataResponseEngineItem;
    facelift?: IIndicataResponseItem;
    identifier?: string;
    make?: IIndicataResponseItem;
    model?: IIndicataResponseItem;
    nextStep?: IIndicataResponseStep[];
    odometer?: IIndicataResponseOdometerItem;
    regDate?: IIndicataResponseItem;
    seats?: IIndicataResponseItem;
    bodyLength?: IIndicataResponseItem;
    bodyHeight?: IIndicataResponseItem;
    overallCondition?: IIndicataResponseConditionItem;
    weight?: IIndicataResponseItem;
    transmission?: IIndicataResponseItem;
    trim?: IIndicataResponseItem;
    valuation?: {
        href?: string;
    }[];
    valuations?: {
        amount?: {
            value?: number;
            currency?: string;
        };
    }[];
    wheelDrive?: IIndicataResponseItem;
    valuationUrl?: string;
    providerData?: {
        providerGroups?: {
            type?: string;
            entries?: {
                key?: string;
                value?: string;
            }[];
        }[];
    };
}
